<template>
    <div class="mainPage">
        <!-- <div class="agentTip" v-if="!isChrome">
            <span>建议使用Chrome浏览器，以获得最佳体验</span>
            <div class="closeTip" @click="isChrome = true">×</div>
        </div> -->
        <div class="header_banner">
            <header>
                <div class="center">
                    <div class="left">
                        <img src="../img/russia_business/CELC-w.png" alt="CELC" class="logo">
                        <img src="../img/russia_business/dalianligong.png" alt="" class="logo">
                        <!-- <a :href="'https://www.chineseplus.net?lang='+language" target="_blank">{{ $t('message.chineseplus') }}</a>
                        <a :href="'https://mooc.chineseplus.net/dist/#/index?lang='+language" target="_blank">{{ $t('message.mooc') }}</a>
                        <a :href="'https://weike.chineseplus.net?lang='+language" target="_blank">{{ $t('message.micClass') }}</a> -->
                        <!-- <a href="http://www.chinesetest.cn/ChangeLan.do" target="_blank">{{ $t('message.HSKExam') }}</a>
                        <a :href="'https://case.chineseplus.net/?lang='+language" target="_blank">{{ $t('message.teachingResource') }}</a> -->
                    </div>
                    <div class="right">
                        <!-- <img src="../img/2022chinesepluslive/lang_icon.png" alt=""> -->
                        <!-- <language class="languageCon" ref="language"></language> -->
                        <div v-if="!isLogin" class="loginCon">
                            <span @click="toLogin()">{{ $t('message.login') }}</span> /
                            <span @click="toLogin()">{{ $t('message.register') }}</span>
                        </div>
                        <div v-if="isLogin" class="loginCon">
                            <span><span class="username">{{user.username}}</span><span @click="toLogOut()">{{ $t('message.logout') }}</span> </span>
                        </div>
                    </div>
                </div>
                
            </header>
            <div class="infoCon">
                <img src="../img/cis_business/banner_info2024.png" alt="" class="banner_info">
                <!-- <img src="../img/2022chinesepluslive/right.png" alt="" class="banner_right"> -->
            </div>
        </div>
        <div class="tabCon">
            <div class="menu">
                班级 группа
                
                <span class="caret"></span>
            </div>
            <div class="classCon">
                <div class="tabBtn" :class="{'activeTab': activeTab == item}" @click="changeTab(item)" v-for="item in classList" :key="item">
                    <div>{{ item }} 班 группа {{ item }}</div>
                </div>
            </div>
        </div>
        <div class="courseListCon">
            
            <ul class="list">
                <li v-for="(item, index) in courseList" :key="item.id" :class="{'live': item.customStatus == 1, 'finished': item.customStatus == 2}">
                    <div class="timeCon" >
                        <span class="time">{{new Date(+item.start_time).Format('YYYY.MM.DD hh:mm')}}-{{new Date(+item.end_time).Format('hh:mm')}}</span>
                        <span class="status live" v-if="item.customStatus == 1">
                            {{ $t('message.classLive') }}
                        </span>
                        <span class="status finished" v-if="item.customStatus == 2">
                            {{ $t('message.classFinished') }}
                        </span>
                    </div>
                    <div class="nameCon">
                        <div class="name">
                            <span>
                                {{item.name}}
                            </span>
                        </div>
                        <!-- <div class="name name_en" v-if="language == 'en'">
                            <span>
                                {{item.name_en}}
                            </span>
                        </div>
                        <div class="name name_en" v-if="language == 'es'">
                            <span>
                                {{item.name_es}}
                            </span>
                        </div>
                        <div class="name name_en" v-if="language == 'fr'">
                            <span>
                                {{item.name_fr}}
                            </span>
                        </div> -->
                        <div class="name name_en">
                            <span>
                                {{item.name_ru}}
                            </span>
                        </div>
                    </div>
                    <div class="titleCon">
                        <div class="title">
                            <div class="cn" >
                                {{item.teacher_name}}
                            </div>
                            <!-- <div class="en" v-if="language == 'en'">
                                <span v-if="item.teacher_name_en">
                                    {{item.teacher_name_en}}
                                </span>
                                <span v-else>
                                    {{item.teacher_name}}
                                </span>
                            </div>
                            <div class="en" v-if="language == 'es'">
                                <span v-if="item.teacher_name_es">
                                    {{item.teacher_name_es}}
                                </span>
                                <span v-else>
                                    {{item.teacher_name}}
                                </span>
                            </div>
                            <div class="en" v-if="language == 'fr'">
                                <span v-if="item.teacher_name_fr">
                                    {{item.teacher_name_fr}}
                                </span>
                                <span v-else>
                                    {{item.teacher_name}}
                                </span>
                            </div> -->
                            <div class="en" v-if="language == 'ru'">
                                <span v-if="item.teacher_name_ru">
                                    {{item.teacher_name_ru}}
                                </span>
                                <span v-else>
                                    {{item.teacher_name}}
                                </span>
                            </div>
                        </div>
                        <div class="liveBtn">
                            <span class="join" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == false" @click="join(item, index, false)">
                                <span class="En">
                                    {{ $t('message.join') }}
                                </span>
                            </span>
                            <span class="join replay" v-if="item.status == 3" @click="replay(item.video_url)">
                                <span class="En">
                                    {{ $t('message.playBack') }}
                                </span>
                            </span>
                            <span class="isOrder" v-if="item.status == 1 && item.customStatus == 0 && item.isOrder == true">
                                {{ $t('message.classnNoBegin') }}
                            </span>
                            <span class="join" v-if="item.status == 1 && item.customStatus == 1" @click="joinToLive(item, index)">
                                <span class="En">
                                    {{ $t('message.enter') }}
                                </span>
                            </span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!-- <div class="guideModel" v-if="isShowGuide">
            <div class="close" @click="isShowGuide = false">×</div>
            <a href="https://z.chineseplus.net/dist/#/pcpage/guide" target="_blank"><img src="../img/cio/chineseplus_guide.png" alt=""></a>
        </div> -->
        <div class="footer">
          版权所有： © 中文联盟
        </div>
        <!-- <pcfooter></pcfooter> -->
        <transition name="fade">
            <div id="videoPlayWrapper" v-if="isPlay">
                <div class="videoContent">
                <div class="closeVideo" @click="closeVideo()">×</div>
                <div class="videoContainer"><video :src="currentVideoUrl" id="liveVideo" controls controlsList="nodownload"></video></div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import Qs from 'qs'
import pcfooter from './footer'
import language from './common/language'
export default {
    name: 'chinesebridge',
    components: {
      pcfooter,
      language
    },
    data: function () {
        return {
            classList: [
              1,2,3,4,5,6,7,8,9,10,11,12,13,14
            ],
            showMemu: false,
            isChrome: true,
            isLogin: false,
            isPlay: false,
            currentVideoUrl: '',
            user: {
                username: '',
                email: ''
            },
            lang: 'cn',
            isShowGuide: true,
            subject_info: {},
            courseList: [],
            activeTab: 1,
            subject_id: null,
            beforeTime: 30, // 提前可进入直播间时间
            afterTime: 30 // 延后关闭直播间时间
        }
    },
    computed: {
        language () {
            return this.$i18n.locale
        }
    },
    methods: {
        changeTab(tab) {
            this.activeTab = tab
            this.getSubjectInfo('dulianti2024-'+this.activeTab)
        },
        tolive (url) {
            window.open(url)
        },
        toLogin() {
            window.location.href =
            this.baseUrl +
            "user/api/login?" +
            "callback=" +
            encodeURIComponent(window.location.href);
        },
        toRegister() {
            window.location.href = 'https://passport.chinesecio.com/static/frontend/dist/#/pc/register?callback=' + encodeURIComponent(window.location.href);
        },
        customCheckLogin() {
            this.checkLogin().then(res => {
                if(res.data.success){
                    this.isLogin = true
                    this.user = res.data.data
                } else {
                    this.isLogin = false
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        toLogOut() {
            this.$utils.get('/user/api/logout').then(res => {
                if(res.data.success) {
                    this.isLogin = false
                }
            })
        },
        // 获取专题信息
        getSubjectInfo(alias) {
          this.courseList = []
            this.$utils.get('/subject/subject/readbyalias', {
                alias
            }).then(res => {
                if(res.data.success) {
                    this.subject_info = res.data.data
                    this.getCourseInfo(this.subject_info.id)
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        // 获取课程列表
        getCourseInfo(id) {
            this.$utils.get('/subject/lesson/getlist', {
                subject_id: id,
                limit: 200
            }).then(res => {
                if(res.data.success) {
                    var now = new Date().getTime()
                    var endTime = now - this.afterTime * 60 * 1000;
                    var nowBeforeFiveMin = now + this.beforeTime * 60 * 1000
                    res.data.data.list.forEach(e => {
                        e.isOrder = false
                        e.customStatus = 0
                        if (nowBeforeFiveMin > e.start_time) {
                            e.customStatus = 1 // 0:直播未开始 1:正在直播 2：直播已结束
                        }
                        if (endTime > e.end_time) {
                            e.customStatus = 2
                        }
                    })
                    this.courseList = res.data.data.list
                    console.log(this.courseList)
                    this.checkOrdeList()
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        // 检查可预约直播间
        checkOrdeList() {
            const orderRoomId = []
            this.courseList.forEach(e => {
                if (orderRoomId.indexOf(e.room_id) == -1 && e.room_id != 0) {
                    orderRoomId.push(e.room_id)
                }
            })
            this.checkRoomsIsOrder(orderRoomId)
        },
        // 检查用户直播间状态
        checkRoomsIsOrder(arr) {
            const data = Qs.stringify({
                rooms: arr.toString(),
                user: this.user.email
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/get_user_rooms'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList.forEach((e, index) => {
                        if (res.data.data.hasOwnProperty(e.room_id)) {
                            this.courseList[index].isOrder = true
                            this.$set (this.courseList, index, this.courseList[index])
                        }
                    })
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        join(item, index, islive) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            const data = Qs.stringify({
                room_id: item.room_id,
                user: this.user.email,
                secret: "03198325b8b61ccc3413cf7e754febea",
                key: "zyz",
                username: this.user.username,
                realname: this.user.username
            })
            this.$utils.thirdPost('https://mooc-stage.chinesecio.com/api/live/add_user'+"?time=" +new Date().valueOf(), data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(res => {
                if (res.data.code == 0) {
                    this.courseList[index].isOrder = true
                    this.$set (this.courseList, index, this.courseList[index])
                    if (islive) {
                        window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
                    }
                }
            }).catch((r) => {
                console.log(r)
            })
        },
        joinToLive(item, index) {
            if(!this.isLogin) {
                this.toLogin()
                return
            }
            if(!item.isOrder) {
                this.join(item, index, true)
            }else {
                window.location.href = 'https://mooc-stage.chinesecio.com/index/login/index.html?room_id=' + item.room_id
            }
        },
        replay(url) {
            this.isPlay = true
            this.currentVideoUrl = url
            setTimeout(function() {
                $('#liveVideo').bind('contextmenu',function() { return false; })
            }, 50)
        },
        closeVideo() {
            var myvideo = document.getElementById("liveVideo");
            if (!myvideo.paused) {
                myvideo.pause();
            }
            this.isPlay = false
        },
        checkChrome() {
            var isChrome = window.navigator.userAgent.indexOf("Chrome") > -1;
            if (!isChrome) {
                this.isChrome = false
            }
        }
    },
    mounted() {
        // this.subject_id = this.$route.query.id
        
        this.customCheckLogin()
        this.getSubjectInfo('dulianti2024-'+this.activeTab)
        this.checkChrome()
        // let activeTab = this.$route.query.tab
        // if(activeTab) {
        //     this.activeTab = activeTab
        // }
        let lang = this.$route.query.lang
        // if(lang) {
        //     this.lang = lang
        //     this.$refs.language.changeLanguage(this.lang)
        // }
        
    }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
.mainPage {
    width: 100%;
    text-align: center;
    position: relative;
    min-height: 100%;
    background-color: #eef3f7;
    .agentTip {
        width: 100%;
        height: 70px;
        line-height: 70px;
        background-color: #ffe6a1;
        text-align: center;
        position: absolute;
        z-index: 5;
        color: #c40000;
    }
    .agentTip .closeTip {
        position: absolute;
        right: 24px;
        top: 0px;
        font-size: 30px;
        color: #282828;
        cursor: pointer;
    }
    .header_banner {
        position: relative;
        // background-image: linear-gradient(0deg, 
		// #ffffff 0%, 
		// #cad9ff 100%), 
        // linear-gradient(
        //     #6187d6, 
        //     #6187d6);
        // background-blend-mode: normal, 
		// normal;
        background-image: url(../img/russia_business/russia_banner.png);
        height: 350px;
        header {
            position: absolute;
            height: 50px;
            line-height: 50px;
            z-index: 2;
            border-bottom: 1px solid rgba(#fff, 0.3);
            top: 0;
            width: 100%;
            margin: auto;
            color: #fff;
            .center {
                color: #8590cc;
                width: 1200px;
                margin: auto;
                a {
                    color: #8590cc;
                    margin-right: 15px;
                    // opacity: 0.8;
                }
            }
            .left {
                float: left;
                .logo {
                  margin-top: 6px;
                  margin-right: 30px;
                }
            }
            .right {
                line-height: 50px;
                float: right;
                color: #fff;
                img {
                    vertical-align: text-top;
                    margin-right: 15px;
                }
                .loginCon {
                    display: inline-block;
                    margin-left: 30px;
                    color: #fff;
                    span {
                        cursor: pointer;
                    }
                    .username {
                        margin-right: 12px;
                    }
                }
            }
        }
    }
    .loginWrapper {
        font-size: 16px;
        color: #fff;
        display: inline-block;
        margin-left: 20px;
        cursor: pointer;
        span {
            margin: 0 5px;
            cursor: pointer;
        }
    }.loginWrapper {
        font-size: 16px;
        color: #fff;
        display: inline-block;
        margin-left: 20px;
        cursor: pointer;
        span {
            margin: 0 5px;
            cursor: pointer;
        }
    }
    .infoCon {
        
        .centerBg {
            width: 1200px;
            margin: auto;
            position: absolute;
            top: 62px;
            left: 0;
            right: 0;
            .left {
                float: left;
                margin-top: 30px;
            }
            .right {
                float: right;
            }
        }
        .banner_right {
            position: absolute;
            right: 0;
            top: 0;
        }
        .banner_left {
            position: absolute;
            left: 0;
            bottom: 0;
        }
        .banner {
            width: 100%;
            height: 350px;
        }
        .info {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 1200px;
            left: 0;
            right: 0;
            margin: auto;
            text-align: left;
            .infoName {
            width: 75%;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            .name {
                font-size:38px;
                color: #fff;
                font-weight: bold;
                line-height:1.2;
            }
            .name_en {
                font-size: 30px;
                color: #fff;
                font-family: Georgia;
                margin-top: 20px;
            }
            }
        }
    }
    .tabCon {
        display: inline-block;
        vertical-align: top;
        width: 350px;
        margin-top: -50px;
        background-color:#fff;
        box-shadow: 0px 3px 5px 0px 
		rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        .menu {
            width: 100%;
            position: relative;
            display: inline-block;
            text-align: left;
            color: #fff;
            // font-weight: bold;
            font-size: 22px;
            height: 50px;
            line-height: 50px;
            padding-left: 30px;
            box-sizing: border-box;
            border-radius: 10px 10px 0 0;
            background-color: #95b2fd;
            cursor: pointer;
            .caret {
                float: right;
                display: inline-block;
                width: 0;
                height: 0;
                margin-top: 25px;
                margin-right: 15px;
                vertical-align: middle;
                border-top: 6px dashed;
                border-top: 6px solid\9;
                border-right: 6px solid transparent;
                border-left: 6px solid transparent;
                opacity: .9;
            }
            .activeCaret {
                border-top: none;
                border-bottom: 6px dashed;
            }
            .menuList {
                position: absolute;
                z-index: 2;
                width: 100%;
                top: 50px;
                font-size: 18px;
                
                left: 0;
                color: #282828;
                font-weight: normal;
                background-color: #fff;
                border-radius: 0 0 4px 4px;
                box-shadow: 0 2px 12px 0 rgba(0,0,0,0.2);
                transition: all linear 0.2s;
                height: 0;
                overflow:hidden;
                span {
                    display: block;
                    height: 50px;
                    padding-left: 30px;
                    box-sizing: border-box;
                    border-bottom: 1px solid #ccc;
                }
                .active {
                    color: #fd9c29;
                }
            }
            .menuActive {
                height: 150px;
            }
        }
        >div {
            // width: 1200px;
            // width: 100%;
            // margin: auto;
            // height: 100%;
            
        }
        .classCon {
          height: 540px;
          overflow-y: auto;
          /*滚动条样式*/
          &::-webkit-scrollbar {
          width: 6px;
          /*height: 4px;*/
          }
          &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          -webkit-box-shadow: inset 0 0 5px rgba(#95b2fd, 0.3);
          background: rgba(#95b2fd, 0.3);
          }
          &::-webkit-scrollbar-track {
          -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
          border-radius: 0;
          background: rgba(0,0,0,0.1);

          }
        }
        .tabBtn {
            text-align: left;
            padding: 20px 30px;
            cursor: pointer;
            font-size: 18px;
            box-sizing: border-box;
        }
        .activeTab {
            background-color: rgba(#95b2fd, 0.3);
            // color: rgb(63, 112, 222);
            // font-weight: bold;
        }
    }
    .courseListCon {
        position: relative;
        z-index: 2;
        display: inline-block;
        vertical-align: top;
        width: 830px;
        min-height: 400px;
        margin:-50px auto 30px;
        background-color:#fff;
        margin-left: 20px;
        box-shadow: 0px 5px 10px 0px 
		rgba(0, 0, 0, 0.1);
	    border-radius: 10px;
        .liveClass {
            padding-top: 60px;
            margin-bottom: 58px;
        }
        .list {
            position: relative;
            padding: 0 18px;
            text-align: left;
            margin-top: 21px;
            &:before {
                position: absolute;
                left: 30px;
                width: 5px;
                height: calc(100% + 66px);
                content: '';
                background-color: #fd9c29;
            }
            li {
                margin-left: 47px;
                margin-bottom: 66px;
                position: relative;
                &:before {
                    position: absolute;
                    left: -47px;
                    top: -6px;
                    content: '';
                    width: 30px;
                    height: 30px;
                    box-sizing: border-box;
                    border-radius: 50%;
                    border: 5px solid #fd9c29;
                    background-color: #fad46b;
                }
                .timeCon {
                    .time {
                        font-size: 24px;
                        color: #5e696d;
                        font-family: "DIN-Medium";
                    }
                    .live {
                        font-size: 16px;
                        color: #379346;
                        margin-left: 60px;
                        vertical-align: text-top;
                    }
                    .finished {
                        font-size: 16px;
                        color: #93a4aa;
                        margin-left: 60px;
                        vertical-align: text-top;
                    }
                }
                .nameCon {
                    margin-top: 31px;
                    margin-bottom: 28px;
                    .name {
                        font-size: 28px;
                        line-height: 1.2;
                        color: #364347;
                        width: 585px;
                    }
                    .name_en {
                        font-size: 20px;
                        line-height: 1.2;
                        color: #93a4aa;
                        margin-bottom: 8px;
                        font-family: 'Georgia';
                        width: 585;
                    }
                }
                .titleCon {
                    .title {
                        color: #fd9c29;
                        display: inline-block;
                        .en {
                            font-size: 20px;
                            font-family: 'Georgia';
                            margin-bottom: 2px;
                            width: 585;
                            line-height: 1.2;
                        }
                        .cn {
                            font-size: 18px;
                            width: 585;
                            line-height: 1.2;
                        }
                    }
                    .liveBtn {
                        float: right;
                        display: inline-block;
                        font-family: 'Georgia';
                        color: #282828;
                        .join {
                            display: inline-block;
                            height: 50px;
                            line-height: 1.2;
                            border-radius: 25px;
                            background-color: #fd9c29;
                            color: #fff;
                            padding: 15px 31px;
                            box-sizing: border-box;
                            cursor: pointer;
                            .En {
                                font-size: 22px;
                                vertical-align: top;
                            }
                            .Cn {
                                font-size: 20px;
                                vertical-align: top;
                            }
                        }
                        .replay {
                            background-color: #4a88da;
                            color: #fff;
                        }
                        .isOrder {
                            color: #999;
                        }
                    }
                }
            }
            .live:before {
                background-color: #43fd61;
            }
            .finished:before {
                background-color: #d6e1e5;
            }
        }
    }
    .footer {
      margin-top: 50px;
      height: 100px;
      line-height: 100px;
      color: #282828;
    }
    .guideModel {
        position: fixed;
        right: 0;bottom: 40px;
        z-index: 5;
        cursor: pointer;
        .close {
            font-size: 28px;
            position: absolute;
            top: 15px;right: 15px;
            color: #fff;
            cursor: pointer;
        }
    }
    #videoPlayWrapper {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 999;
    }
    #videoPlayWrapper .closeVideo {
        position: absolute;
        right: 20px;
        top: 10px;
        font-size: 50px;
        color: #fff;
        cursor: pointer;
    }
    .videoContent {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .videoContainer {
        text-align: center;
        width: 100%;
    }
    .videoContainer video {
        width: 62%;
    }
    video::-internal-media-controls-download-button {
        display:none;
    }
    video::-webkit-media-controls-enclosure {
        overflow:hidden;
    }
    video::-webkit-media-controls-panel {
        width: calc(100% + 30px);
    }
}

</style>
